import { Anexo, AnexoNovo } from "../../pages/suporte/types";

// O corpo salvo nunca guarda uma `src`: cada imagem no meio do texto vira uma
// referência ao anexo (`data-anexo-id` para o que já existe, `data-anexo-idx`
// para o que ainda vai ser gravado). A URL só é montada na hora de exibir.
const ATTR_ID = "data-anexo-id";
const ATTR_IDX = "data-anexo-idx";

function parse(html: string): Document {
  return new DOMParser().parseFromString(String(html ?? ""), "text/html");
}

export interface Serializado {
  html: string;
  imagens: AnexoNovo[];
  idsMantidos: string[];
}

export function serializarInline(
  html: string,
  novos: AnexoNovo[],
  publicados: Anexo[] = [],
): Serializado {
  const doc = parse(html);
  const porDataUrl = new Map(novos.map((anexo) => [anexo.url, anexo]));
  const porUrl = new Map(publicados.map((anexo) => [anexo.url, anexo]));

  const imagens: AnexoNovo[] = [];
  const idsMantidos: string[] = [];

  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src") ?? "";
    const idExistente = img.getAttribute(ATTR_ID) ?? porUrl.get(src)?.id;
    const novo = porDataUrl.get(src);

    if (idExistente) {
      img.removeAttribute("src");
      img.setAttribute(ATTR_ID, idExistente);
      idsMantidos.push(idExistente);
      return;
    }
    if (novo) {
      img.removeAttribute("src");
      img.setAttribute(ATTR_IDX, String(imagens.length));
      imagens.push(novo);
      return;
    }
    img.remove();
  });

  const naoImagens = novos.filter((anexo) => anexo.tipo !== "imagem");

  removerParagrafosVaziosNasPontas(doc.body);

  return {
    html: doc.body.innerHTML,
    imagens: [...imagens, ...naoImagens],
    idsMantidos,
  };
}

// O Quill deixa um <p><br></p> sobrando quando a mensagem termina numa linha
// em branco; sem isso o comentário é salvo com um espaço vazio embaixo do texto.
function ehParagrafoVazio(el: Element): boolean {
  return el.tagName === "P" && !el.querySelector("img") && !el.textContent?.trim();
}

function removerParagrafosVaziosNasPontas(body: HTMLElement): void {
  while (body.lastElementChild && ehParagrafoVazio(body.lastElementChild)) {
    body.lastElementChild.remove();
  }
  while (body.firstElementChild && ehParagrafoVazio(body.firstElementChild)) {
    body.firstElementChild.remove();
  }
}

export function hidratarInline(html: string, anexos: Anexo[]): string {
  const texto = String(html ?? "");
  if (!texto.includes(ATTR_ID)) return texto;

  const doc = parse(texto);
  const porId = new Map(anexos.map((anexo) => [String(anexo.id), anexo]));

  doc.querySelectorAll(`img[${ATTR_ID}]`).forEach((img) => {
    const anexo = porId.get(img.getAttribute(ATTR_ID) ?? "");
    if (!anexo) {
      img.remove();
      return;
    }
    img.setAttribute("src", anexo.url);
    img.setAttribute("alt", anexo.nome ?? "");
  });

  return doc.body.innerHTML;
}

export function idsInlineDoHtml(html: string): string[] {
  const texto = String(html ?? "");
  if (!texto.includes(ATTR_ID)) return [];

  return Array.from(parse(texto).querySelectorAll(`img[${ATTR_ID}]`)).map(
    (img) => img.getAttribute(ATTR_ID) as string,
  );
}
